// eslint-disable react-hooks/exhaustive-deps
import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';
import PreOrder, { TAB_STATUS_MAP } from '../components/PreOrder';
import { useAuthState } from '../../preorder/plugins/Auth';
import withTapPay from '../../hocs/withTapPay';
import { checkout } from '../api/menu';
import { PAYMENT_METHOD } from '../../preorder/containers/CheckoutPage/components/Checkout';
import preOrderAPI from '../../preorder/api/preOrder';
import { useProgressContext } from '../../preorder/contexts/useProgressContext';
import useAuth from '../../preorder/hooks/useAuth';

export const paymentMethodMap = {
  [PAYMENT_METHOD.TAP_PAY]: 'tap pay',
  [PAYMENT_METHOD.TAP_PAY_3D]: 'tap pay 3d',
  [PAYMENT_METHOD.LINE_PAY]: 'line pay',
  [PAYMENT_METHOD.ENTERPRISE_CARD_PAY]: 'enterprise card pay',
};

export default withTapPay(({
  params,
  selectedFridge,
}) => {
  const history = useHistory();
  const location = useLocation();
  const startOfToday = moment().utcOffset(8).startOf('day');
  const [alert, setAlert] = React.useState(null);
  const [checkAuthenticated] = useAuth();
  const [creatingOrder, setCreatingOrder] = useState(false);
  const [orderModalData, setOrderModalData] = useState(undefined);
  const [selectedMoment, setSelectedMoment] = useState(moment());
  const [startMoment, setStartMoment] = useState(moment().utcOffset(8).startOf('week').add(1, 'day'));
  const { pathname, state } = location;
  const { modalData, selectedMomentAfterLogin } = state || {};
  const { start: startProgress, end: endProgress } = useProgressContext();
  const { token } = useAuthState();

  useEffect(() => {
    if (selectedMomentAfterLogin && modalData) {
      setOrderModalData(modalData);
      setCreatingOrder(true);
    }
  }, [
    modalData,
    selectedMomentAfterLogin,
    setCreatingOrder,
    setOrderModalData,
    setSelectedMoment,
  ]);

  useEffect(() => {
    const weekDay = selectedMoment.day();
    if (weekDay === 0) setSelectedMoment(startMoment.clone());
    if (weekDay === 6) {
      const newStartMoment = startMoment.clone().add(1, 'week');

      setStartMoment(newStartMoment);
      setSelectedMoment(newStartMoment);
    }
    if (selectedMomentAfterLogin) {
      setSelectedMoment(moment(selectedMomentAfterLogin));
      history.replace();
    }
  }, [selectedMoment, startMoment, setStartMoment, selectedMomentAfterLogin, history]);

  useEffect(() => {
    if (modalData) setOrderModalData(modalData);
  }, [modalData, setOrderModalData]);

  const datesToDispaly = useMemo(() => {
    const result = [];
    for (let i = 0; i < 5; i += 1) {
      const displayMoment = startMoment.clone().add(i, 'day');
      let status = TAB_STATUS_MAP.NORMAL;

      if (displayMoment.isSame(selectedMoment, 'day')) status = TAB_STATUS_MAP.SELECTED;
      if (displayMoment.isBefore(startOfToday)) status = TAB_STATUS_MAP.OVERDUE;

      result.push({
        displayText: displayMoment.format('MM/DD'),
        moment: displayMoment,
        status,
      });
    }
    return result;
  }, [startMoment, selectedMoment, startOfToday]);

  const data = useMemo(() => {
    const currentMoment = moment();
    const terminateMoment = selectedMoment.clone().hour(9).minute(30);
    const key = selectedMoment.format('YYYYMMDD');
    const {
      rawData,
      products: paramsProductsDict,
      productProviderInfo: productProviderInfoDict,
    } = params || {};
    const { [key]: fridgeProductsDict } = rawData || {};
    const { [selectedFridge]: productsDict } = fridgeProductsDict || {};
    const types = [];
    const typeProvidersDict = {};
    const typeProviderProductsDict = {};

    Object.keys(productsDict || {})
      .forEach((productId) => {
        const { [productId]: product } = paramsProductsDict || {};
        const { type, provider: providerName, productNumber } = product || {};
        const typeProviderKey = `${type}-${providerName}`;

        if (['TS', 'SA', 'PO'].some((keyword) => (productNumber || '').includes(keyword))) return;

        if (!typeProvidersDict[type]) typeProvidersDict[type] = [];
        if (!typeProviderProductsDict[typeProviderKey]) {
          typeProviderProductsDict[typeProviderKey] = [];
        }

        const typeProviders = typeProvidersDict[type];
        const typeProviderProducts = typeProviderProductsDict[typeProviderKey];
        const { price: productPrice } = product || {};

        typeProviderProducts.push({
          id: productId,
          coverImage: productProviderInfoDict[providerName]?.coverImage,
          isShowOrderButton: currentMoment.isBefore(terminateMoment),
          ...product,
          price: parseInt(0.95 * productPrice, 10),
        });

        if (!typeProviders.find(({ provider }) => provider === providerName)) {
          const productProviderInfo = productProviderInfoDict[providerName];
          const {
            coverImage,
            unsharedCoverImage,
          } = productProviderInfo || {};

          typeProviders.push({
            ...productProviderInfoDict[providerName],
            images: [coverImage, unsharedCoverImage].filter((i) => i).join('+'),
          });
        }
      });

    Object.entries(typeProvidersDict).forEach(([type, providers]) => {
      types.push({
        type,
        providers: providers.map((provider) => {
          const { provider: providerName } = provider;
          return {
            ...provider,
            products: typeProviderProductsDict[`${type}-${providerName}`],
          };
        }),
      });
    });

    return types;
  }, [
    params,
    selectedFridge,
    selectedMoment,
  ]);

  const onOrderClick = useCallback((product) => {
    try {
      if (!product) throw new Error('the product not found');
      if (!selectedFridge) throw new Error('the fridgeId not found');

      const fridge = params.fridges[selectedFridge] || {};
      const { name: fridgeName, address } = fridge || {};

      if (!fridgeName) throw new Error('the fridgeName not found');

      const modalDataToOpen = {
        fridge: {
          address,
          id: selectedFridge,
          ...fridge,
        },
        product: {
          ...product,
          name: `${product.name}預訂取貨券`,
        },
        redeemStartTime: +selectedMoment,
      };

      if (!checkAuthenticated()) {
        history.push('/register', {
          afterLoginUrl: `${pathname}`,
          selectedMomentAfterLogin: +selectedMoment,
          modalData: modalDataToOpen,
        });

        return;
      }

      setOrderModalData(modalDataToOpen);
      setCreatingOrder(true);
    } catch (e) {
      console.log(e.message);
    }
  }, [
    history,
    params,
    pathname,
    selectedFridge,
    selectedMoment,
    checkAuthenticated,
  ]);

  const onOrderModalClose = useCallback(() => {
    setCreatingOrder(false);
    setOrderModalData(undefined);
  }, [setCreatingOrder, setOrderModalData]);

  const onOrderModalOrderButtonClick = useCallback(async (orderData) => {
    startProgress();

    try {
      const {
        paymentInfo, paymentMethod, items, totalPrice,
      } = orderData || {};

      if (!paymentMethod) throw new Error('請選擇支付方式');
      if (!items) throw new Error('請選擇要購買的商品');

      if (paymentMethod === PAYMENT_METHOD.LINE_PAY) {
        const result = await preOrderAPI.createLinePayRequestInfo({
          body: {
            token,
            linePayRedirectUrl: `${window.location.origin}/checkout/line-pay-payment?submitLinePay=true`,
            preChargeAmount: totalPrice,
          },
        });

        const { status, redirectUrl } = result || {};

        if (status !== 'OK') throw new Error('LINE PAY 交易失敗，請聯繫客人員。');
        if (!redirectUrl) throw new Error('LINE PAY 交易失敗，請聯繫客人員。');

        window.localStorage.setItem('checkoutSummary', JSON.stringify({
          from: 'DF_PO',
          items,
        }));

        window.location.href = redirectUrl;

        return false;
      }

      const checkoutResult = await checkout({
        items,
        paymentInfo,
        paymentMethod: paymentMethodMap[paymentMethod],
        token,
      });
      const { status, orderId } = checkoutResult || {};

      if (status !== 'success') throw new Error('結帳失敗，請聯繫客人員。');

      onOrderModalClose();

      history.replace('/checkout/menu/receipt', {
        items,
        orderId,
      });
    } catch (e) {
      setAlert({
        title: '交易失敗',
        message: e.message,
      });
    }

    endProgress();

    return true;
  }, [token, startProgress, endProgress, onOrderModalClose, history]);

  const onAlertButtonClick = useCallback(() => {
    setAlert(undefined);
  }, [setAlert]);

  return (
    <PreOrder
      alert={alert}
      creatingOrder={creatingOrder}
      data={data}
      datesToDispaly={datesToDispaly}
      isAlertOpen={!!alert}
      onAlertButtonClick={onAlertButtonClick}
      onDateClick={setSelectedMoment}
      onOrderClick={onOrderClick}
      onOrderModalClose={onOrderModalClose}
      onOrderModalOrderButtonClick={onOrderModalOrderButtonClick}
      orderModalData={orderModalData}
      selectedFridge={selectedFridge}
    />
  );
});
